/* -------------------- DRAWERS -------------------- */

// MENU DRAWER
$(document).on("click", "#drawer-toggle", function () {
  $('#menu-drawer').addClass('open');
  $('.custom_overlay').addClass('active');
});

$(document).on("click", "#drawer-close", function () {
  $('#menu-drawer').removeClass('open');
  $('.custom_overlay').removeClass('active');
});

// CART DRAWER
$(document).on("click", "#cart-toggle, .custom-cart-icon", function () {
  $('#cart-drawer').addClass('open');
  $('.custom_overlay2').addClass('active');
});

$(document).on("click", "#cart-close,.cart_empty_button", function () {
  $('#cart-drawer').removeClass('open');
  $('.custom_overlay2').removeClass('active');
});

// GLOBAL CLICK OUTSIDE (single handler)
$(document).on("click", function (e) {
  if (!$(e.target).closest('#menu-drawer, #drawer-toggle').length) {
    $('#menu-drawer').removeClass('open');
    $('.custom_overlay').removeClass('active');
  }

  if (!$(e.target).closest('#cart-drawer, #cart-toggle, .custom-cart-icon').length) {
    $('#cart-drawer').removeClass('open');
    $('.custom_overlay2').removeClass('active');
  }
});

/* -------------------- MENU -------------------- */

$(document).on('click', '.drawer-menu-item.has-children > .parent-link', function(e) {
  e.preventDefault();
  $(this).siblings('.sub-menu').addClass('open');
});

$(document).on('click', '.sub-menu .back-btn a', function(e) {
  e.preventDefault();
  $(this).closest('.sub-menu').removeClass('open');
});

/* -------------------- CART HELPERS -------------------- */

function updateCartCount(){
  $.getJSON('/cart.js', function(cart){
    $('.custom-cart-icon .cart-count').text(cart.item_count);
  });
}

function refreshCartDrawer() {
  return $.ajax({
    url: window.location.pathname,
    type: 'GET',
    dataType: 'html',
    success: function (data) {
      const $newDrawer = $(data).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($newDrawer);
      updateCartCount();
    }
  });
}

function updateCart(variantId, quantity, key, sellingPlan = null) {
  return $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: key,
      quantity: quantity,
      selling_plan: sellingPlan || null
    }),
    contentType: 'application/json',
    dataType: 'json'
  });
}

/* -------------------- QUANTITY -------------------- */

$(document).on('click', '.quantity_plus, .quantity_minus', function () {
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $input = $wrap.find('input[name="quantity_single"]');

  let qty = parseInt($input.val()) || 0;

  if ($(this).hasClass('quantity_plus')) qty++;
  else qty = Math.max(0, qty - 1);

  $input.val(qty);

  updateCart(null, qty, $input.attr('key'), $input.attr('selling_plan'))
    .then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- REMOVE -------------------- */

$(document).on('click', '.cart_item_single_right_remove', function () {
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const key = $(this).attr('key');

  updateCart(null, 0, key)
    .then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- RECOMMENDED PRODUCT -------------------- */

$(document).on("click", ".recommended_product_button", function(e) {
  e.preventDefault();

  const $btn = $(this).addClass("loading_hk");

  $.post("/cart/add.js", {
    quantity: $btn.attr("quantity"),
    id: $btn.attr("variant_id"),
    selling_plan: $btn.attr("selling_plan")
  }, function() {
    onCartUpdated();
    $("#cart-drawer").removeClass("is_empty").addClass("open");
    $btn.removeClass("loading_hk");
  });
});

/* -------------------- SHIPPING PROTECTION -------------------- */

$(document).on("click", ".shipping_protection_flex", function (e) {
  e.preventDefault();

  const $btn = $(this).find('.shipping_protection_add').toggleClass('active');
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');

  if ($btn.hasClass('active')) {
    $.post('/cart/add.js', {
      id: $btn.attr('variant_id'),
      quantity: 1
    }).then(onCartUpdated)
      .finally(() => $drawer.removeClass('loading_hk'));
  } else {
    $('.cart_item_single img[alt="Shipping Protection"]')
      .closest('.cart_item_single')
      .find('.cart_item_single_right_remove')
      .trigger('click');
  }
});

/* -------------------- REPL0 FIX -------------------- */

document.addEventListener("click", function(e){

  const btn = e.target.closest("[data-replo-add-product-variant-to-cart]");
  if(!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const form = btn.closest("[data-replo-product-container]").querySelector("form");
  const formData = new FormData(form);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData
  })
  .then(() => {
    onCartUpdated();
    $('#cart-drawer').addClass('open');
    $('.custom_overlay2').addClass('active');
  });

}, true);

/* -------------------- SUBSCRIPTION TOGGLE -------------------- */

$(document).on("click", ".subscription_toggle", function () {

  const $el = $(this);
  const $item = $el.closest(".cart_item_single");
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');

  const payload = {
    id: $item.data("key"),
    quantity: parseInt($item.find("input").val()),
    selling_plan: $el.data("selling-plan") ? null : $el.data("default-selling-plan")
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    contentType: "application/json",
    data: JSON.stringify(payload)
  }).then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- FREE GIFTS -------------------- */

const FREE_VARIANT = 57431390355840;
const FREE_GIFT_2 = 57849885819264;

let isUpdatingFreeGifts = false;

function checkSubscriptionAndFreeProduct() {

  if (isUpdatingFreeGifts) return;
  isUpdatingFreeGifts = true;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const $drawer = $('#cart_drawer_content');

      const free1 = cart.items.find(
        item => item.variant_id === FREE_VARIANT
      );

      const free2 = cart.items.find(
        item => item.variant_id === FREE_GIFT_2
      );

      /* -------------------- GIFT 1 -------------------- */
      /* Add if cart contains anything with value */

      const hasCartValue = cart.total_price > 0;
      const shouldHaveFreeGift1 = hasCartValue;

      /* -------------------- GIFT 2 -------------------- */
      /* Add if any non-gift product contains X3 */

      const hasX3Product = cart.items.some(item => {

        const isGiftVariant = [
          FREE_VARIANT,
          FREE_GIFT_2
        ].includes(item.variant_id);

        if (isGiftVariant) return false;

        const title = [
          item.product_title || '',
          item.variant_title || ''
        ]
          .join(' ')
          .toUpperCase();

        return title.includes('X3');
      });

      const shouldHaveFreeGift2 = hasX3Product;

      let promises = [];

      /* ---------- FREE PRODUCT 1 ---------- */

      if (shouldHaveFreeGift1 && !free1) {
        promises.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: FREE_VARIANT,
              quantity: 1
            })
          })
        );
      }

      if (!shouldHaveFreeGift1 && free1) {
        promises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: free1.key,
              quantity: 0
            })
          })
        );
      }

      /* ---------- FREE PRODUCT 2 ---------- */

      if (shouldHaveFreeGift2 && !free2) {
        promises.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: FREE_GIFT_2,
              quantity: 1
            })
          })
        );
      }

      if (!shouldHaveFreeGift2 && free2) {
        promises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: free2.key,
              quantity: 0
            })
          })
        );
      }

      if (promises.length) {

        $drawer.addClass('loading_hk');

        Promise.all(promises)
          .then(onCartUpdated)
          .finally(() => {
            $drawer.removeClass('loading_hk');
            isUpdatingFreeGifts = false;
          });

      } else {
        isUpdatingFreeGifts = false;
      }

    })
    .catch(() => {
      isUpdatingFreeGifts = false;
    });
}

/* -------------------- CENTRAL CART UPDATE -------------------- */

function onCartUpdated() {
  refreshCartDrawer().then(() => {
    checkSubscriptionAndFreeProduct();
  });
}

/* -------------------- INIT -------------------- */

document.addEventListener('DOMContentLoaded', function () {
  checkSubscriptionAndFreeProduct();
});

/* -------------------- VH FIX -------------------- */

function updateVh() {
  document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
}
window.addEventListener('resize', updateVh);
window.addEventListener('load', updateVh);